import React from 'react';

const colorsIcon = state => (state ? '#24A95D' : '#fff');
const opacityIcon = state => (state ? 1 : 0.5);

export const IconControl = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 5.071H1c-.552 0-1-.511-1-1.142V1.643C0 1.012.448.5 1 .5h14c.552 0 1 .512 1 1.143v2.286c0 .63-.448 1.142-1 1.142ZM13.5 1.93c-.414 0-.75.383-.75.857 0 .473.336.857.75.857s.75-.384.75-.857c0-.474-.336-.857-.75-.857Zm-2 0c-.414 0-.75.383-.75.857 0 .473.336.857.75.857s.75-.384.75-.857c0-.474-.336-.857-.75-.857Zm3.5 8.857H1c-.552 0-1-.512-1-1.143V7.357c0-.631.448-1.143 1-1.143h14c.552 0 1 .512 1 1.143v2.286c0 .631-.448 1.143-1 1.143Zm-1.5-3.143c-.414 0-.75.384-.75.857s.336.857.75.857.75-.384.75-.857-.336-.857-.75-.857Zm-2 0c-.414 0-.75.384-.75.857s.336.857.75.857.75-.384.75-.857-.336-.857-.75-.857ZM15 16.5H1c-.552 0-1-.512-1-1.143v-2.286c0-.63.448-1.142 1-1.142h14c.552 0 1 .511 1 1.142v2.286c0 .631-.448 1.143-1 1.143Zm-1.5-3.143c-.414 0-.75.384-.75.857 0 .474.336.857.75.857s.75-.383.75-.857c0-.473-.336-.857-.75-.857Zm-2 0c-.414 0-.75.384-.75.857 0 .474.336.857.75.857s.75-.383.75-.857c0-.473-.336-.857-.75-.857Z"
      fill={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconRelatorios = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4.8h3.429V16H0V4.8ZM6.4 0h3.2v16H6.4V0Zm6.4 9.143H16V16h-3.2V9.143Z"
      fill={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconHistorico = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0a9 9 0 0 0-9 9H0l3.89 3.89.07.14L8 9H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 12 18a9 9 0 0 0 0-18Zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V5H11Z"
      fill={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconCadastro = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.896 11.045a3.995 3.995 0 0 0 0-1.521l.968-.533a.253.253 0 0 0 .123-.303 5.305 5.305 0 0 0-1.245-2.05.283.283 0 0 0-.337-.05l-.968.531a4.461 4.461 0 0 0-1.384-.76V5.294a.263.263 0 0 0-.213-.254 5.934 5.934 0 0 0-2.483 0 .263.263 0 0 0-.214.254v1.065a4.461 4.461 0 0 0-1.384.76l-.967-.532a.284.284 0 0 0-.338.05 5.308 5.308 0 0 0-1.245 2.05.258.258 0 0 0 .124.304l.967.533a3.991 3.991 0 0 0 0 1.521l-.967.533a.253.253 0 0 0-.124.303 5.335 5.335 0 0 0 1.245 2.05c.086.09.225.111.338.05l.967-.532c.409.333.878.59 1.384.761v1.065c0 .121.09.229.214.253a5.935 5.935 0 0 0 2.483 0 .263.263 0 0 0 .213-.253V14.21a4.462 4.462 0 0 0 1.384-.76l.968.532c.109.06.251.039.337-.05a5.306 5.306 0 0 0 1.245-2.05.258.258 0 0 0-.123-.304l-.968-.533Zm-4.294.972c-1.005 0-1.819-.779-1.819-1.733 0-.953.818-1.732 1.819-1.732s1.819.779 1.819 1.732c0 .954-.814 1.733-1.819 1.733ZM3.6 6.855C4.924 6.855 6 5.83 6 4.57c0-1.261-1.076-2.286-2.4-2.286-1.324 0-2.4 1.025-2.4 2.286 0 1.26 1.076 2.286 2.4 2.286Zm8.401 1.143c.072 0 .139-.018.21-.021a6.54 6.54 0 0 1 1.362-2.115c.277-.286.671-.45 1.083-.45.26 0 .514.064.736.19l.296.164c.03-.018.06-.033.09-.05.262-.522.42-1.1.42-1.715 0-2.211-1.879-4.001-4.2-4.001C9.675 0 7.8 1.786 7.8 3.997 7.8 6.21 9.68 7.998 12 7.998Zm3.946 6.948c-.087-.043-.173-.093-.255-.14-.308.172-.574.351-1.032.351-.409 0-.802-.164-1.084-.45a6.448 6.448 0 0 1-1.507-2.486c-.402-1.233.934-1.776.967-1.797a3.408 3.408 0 0 1 0-.279l-.296-.164a1.514 1.514 0 0 1-.367-.29c-.124.008-.244.022-.368.022a6.164 6.164 0 0 1-2.569-.572h-.311c-2.39 0-4.324 1.844-4.324 4.116v1.028c0 .947.806 1.715 1.8 1.715h9.578a1.329 1.329 0 0 1-.232-.725v-.329ZM6.492 8.663A2.455 2.455 0 0 0 4.8 7.998H2.4C1.075 7.998 0 9.023 0 10.284v1.144c0 .632.536 1.143 1.2 1.143h2.472c.236-1.694 1.309-3.119 2.82-3.908Z"
      fill={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconConsultasExternas = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m15.782 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51A6.467 6.467 0 0 0 13 6.5C13 2.91 10.09 0 6.5 0a6.5 6.5 0 1 0 0 12.999 6.47 6.47 0 0 0 4-1.375v.51c0 .2.078.39.219.53l3.116 3.116a.747.747 0 0 0 1.059 0l.884-.885a.753.753 0 0 0 .003-1.062ZM6.501 11c-2.486 0-4.5-2.01-4.5-4.5C2 4.014 4.01 2 6.5 2 8.986 2 11 4.01 11 6.5c0 2.485-2.011 4.499-4.5 4.499Zm0-7.499a2.307 2.307 0 0 0-2.307 2.307c0 1.03 1.508 2.908 2.086 3.59a.289.289 0 0 0 .443 0c.578-.682 2.086-2.56 2.086-3.59A2.307 2.307 0 0 0 6.5 3.5Zm0 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
      fill={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconGestao = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.184 17v-6.222M3.182 7.222V1M9 17V9M9 5.444V1M14.816 17v-4.444M14.818 9V1M1 10.778h4.364M6.816 5.444h4.364M12.637 12.556H17"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={colorsIcon(active)}
      strokeOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconInformacoes = React.memo(({ active = false }) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.125 9.125a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75M7.875 9.125a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75"
      stroke={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
    <path
      d="M21.75 7.25v-1.5a1.5 1.5 0 0 0-1.5-1.5h-18a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5H7.5"
      stroke={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
    <path
      d="M15.75 18.5a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5ZM23.25 20.75l-3.788-3.788"
      stroke={colorsIcon(active)}
      fillOpacity={opacityIcon(active)}
    />
  </svg>
));

export const IconSair = React.memo(() => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 18 19"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.5}
      d="m7.09 13.29 1.41 1.488 5-5.278-5-5.278-1.41 1.489 2.58 2.733H0v2.112h9.67l-2.58 2.733ZM16 0H2C.89 0 0 .95 0 2.111v4.222h2V2.111h14V16.89H2v-4.222H0v4.222C0 18.05.89 19 2 19h14c1.1 0 2-.95 2-2.111V2.11C18 .95 17.1 0 16 0Z"
    />
  </svg>
));
